export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-chat-3-line',
      title: 'ヒアリング',
      duration: '約30分',
      description: 'お店の特徴やご希望をお伺いします'
    },
    {
      number: '2',
      icon: 'ri-palette-line',
      title: 'デザイン制作',
      duration: '3〜5日',
      description: 'ご要望をもとにHPをデザイン・制作'
    },
    {
      number: '3',
      icon: 'ri-eye-line',
      title: '確認',
      duration: '1〜2日',
      description: '完成イメージを確認。修正があれば対応'
    },
    {
      number: '4',
      icon: 'ri-rocket-line',
      title: '公開',
      duration: '1日',
      description: 'ドメイン設定・公開。運用スタート！'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            制作の流れ
          </h2>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Arrow for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 -right-5 z-20 items-center justify-center">
                  <i className="ri-arrow-right-line text-3xl text-cyan-600"></i>
                </div>
              )}
              
              <div className="relative z-10 bg-white rounded-2xl p-6 border-2 border-slate-200 hover:border-cyan-600 transition-all duration-300 hover:shadow-xl text-center">
                {/* Step Number */}
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-600 text-white text-xl font-bold rounded-full mx-auto mb-4">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center bg-cyan-100 rounded-full mx-auto mb-4">
                  <i className={`${step.icon} text-3xl text-cyan-600`}></i>
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-slate-800 mb-2">
                  {step.title}
                </h3>
                
                {/* Duration */}
                <p className="text-amber-600 font-semibold mb-3">
                  {step.duration}
                </p>
                
                {/* Description */}
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="text-center">
          <p className="text-2xl font-bold text-cyan-600">
            最短1週間でHPを公開できます
          </p>
        </div>
      </div>
    </section>
  );
}